import { render } from "./Main.vue?vue&type=template&id=fb4ffe1e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=fb4ffe1e&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=fb4ffe1e&lang=css"
script.render = render
script.__scopeId = "data-v-fb4ffe1e"

export default script